import type { ProfileFields, ProfileReadOnlyFields } from './profile';

export const USER_PROFILE_FIELDS: ProfileFields[] = [
  'academicMetrics',
  'academicApTests',
  'academicEntranceExams',
  'academicExtracurricularInvolvement',
  'academicRigor',
  'academicDegrees',
  'academicEnrollmentTypes',
  'academicsHighSchoolCurrentEnrollment',
  'academicsPostSecondaryCurrentEnrollment',
  'academicsAlmaMaters',
  'academicMajors',
  'academicHighSchoolExpectedGraduationYear',
  'academicPostSecondaryExpectedGraduationYear',
  'academicHighSchoolProgramStartTerm',
  'academicHighSchoolProgramStartYear',
  'academicPostSecondaryProgramStartTerm',
  'academicPostSecondaryProgramStartYear',
  'academicEducationalExperiences',

  'careerExperiences',
  'careerOccupation',
  'careerEmployer',
  'careerPaths',

  'demographicsGenders',
  'demographicsEthnicities',
  'demographicsReligions',
  'demographicsAffinities',
  'demographicsRelationshipExperiences',
  'demographicsFamilyRoles',
  'demographicsChildhoodExperiences',
  'demographicsMyersBriggs',
  'demographicsHigh5s',
  'demographicsStrengthsFinders',
  'demographicsAstrologySigns',

  'financialExperiences',
  'financialCredentials',
  'financialProfile',
  'financialFamilyIncomes',

  'healthMentalHealthInterests',
  'healthInterests',
  'healthFoodNutrition',
  'healthExperiences',

  'hobbiesCreativeInterests',
  'hobbiesPassions',
  'hobbiesFavorites',

  'resourcesClubs',
  'resourcesLanguages',

  'documentsResumes',
  'documentsTranscripts',
  'documentsPersonalAssessment',
  'documentsOther',
  'documentsPurposeVideo',

  'linkedInData',

  'user_bio',

  'publicProfile',
];

/** Kept out of USER_PROFILE_FIELDS, which loads on every page. */
export const STUDENT_PROGRAM_FIELDS: ProfileReadOnlyFields[] = [
  'studentType',
  'sponsoringInstitutions',
];
